import { buildProductQuery } from '../graphql'
import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useConfirmDialog, useMutation } from '@ztechapps/common.hook'
import type { Product } from '@ztechapps/common.contract'
import merge from 'lodash/merge'

const deleteConfig = buildProductQuery().deleteConfig

export const useDeleteProduct = (
  { query, ...restProps } = {} as UseMutationProps
): UseActionResult<Product, Product> => {
  const { confirm } = useConfirmDialog({
    title: 'Delete product?',
    text: 'You cannot recover once it was deleted. If the product is used on sales orders, purchase order, build, bill of materials, related products, adjustment, production, inventories it will not be deleted.',
  })

  const { query: defaultQuery, ...restDeleteConfig } = deleteConfig
  query = query ?? defaultQuery

  const mergeResult = merge(restDeleteConfig, restProps)

  const [onDelete, , { error, loading }] = useMutation<{ deleteProduct: Product }, Product>({ query, ...mergeResult })

  const onAction = async (product: Product) => {
    const confirmFunction = async () => {
      const { data } = await onDelete({ input: { _id: product._id } as Product })
      return data.deleteProduct
    }

    return confirm(confirmFunction)
  }

  return [onAction, { error, loading }]
}
